import React, { useEffect, useState } from "react";
import { Box, Typography, makeStyles, IconButton, Tooltip } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import AppDialog from "components/Dialog/AppDialog";
import GetAppIcon from '@material-ui/icons/GetApp';
import moment from "moment";
import PreviewDialog from "components/Dialog/PreviewDialog";

const useStyles = makeStyles(() => ({
  row: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "12px",
    borderBottom: "1px solid #E5E7EB",
    "&:last-child": {
      borderBottom: "none",
    },
  },
  fileName: {
    fontSize: 13,
    fontWeight: 600,
    color: "#111827",
    marginBottom: 4,
  },
  fileDate: {
    fontSize: 12,
    color: "#6B7280",
  },
  downloadBtn: {
    color: "#0D9488",
  },
}));

const DocumentVersionsModal = ({ open, onClose, details = [], localFiles = [], documentName, fileNameKey, fileLinkKey }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [listPast, setListPast] = useState([]);
  const [current, setCurrent] = useState(null);
  const [showPdfModal, setShowPdfModal] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);

  const sortByCreatedDateDesc = (dataArray) => {
    return dataArray.sort((a, b) => {
      return new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime();
    });
  };

  useEffect(() => {
    const sortedDetails = sortByCreatedDateDesc(details);

    setCurrent(sortedDetails?.[0]);
    setListPast(sortedDetails.slice(1));
  }, [details]);

  console.log('current', current);
  console.log('listPast', listPast);

  return (
    <AppDialog
      open={open}
      onClose={onClose}
      title={t("document.documentVersions")}
      maxWidth="sm"
    >
      <Box>
        {(current || localFiles.length > 0) ? (
          <>
            {documentName && (
              <Typography variant="subtitle1" style={{ fontWeight: 700, color: '#0D9488', marginBottom: 16, marginTop: 8 }}>
                {documentName}
              </Typography>
            )}

            {/* New Version section - local files not yet saved */}
            {localFiles.length > 0 && (
              <>
                <Typography variant="subtitle2" style={{ fontWeight: 700, color: '#374151', marginBottom: 8, marginTop: documentName ? 0 : 8, textTransform: 'uppercase' }}>
                  {t("label.newVersion")}
                </Typography>
                <Box style={{ border: '1px solid #E5E7EB', borderRadius: 8, marginBottom: 16, backgroundColor: '#F0FDF4' }}>
                  {localFiles.map((localFile, index) => (
                    <Box key={index} className={classes.row} style={{ borderBottom: index < localFiles.length - 1 ? '1px solid #E5E7EB' : 'none' }}>
                      <Box>
                        <Typography className={classes.fileName}>
                          {localFile.fileName}
                        </Typography>
                        <Typography className={classes.fileDate}>
                          {t("label.notSaved")}
                        </Typography>
                      </Box>
                      {localFile.fileUrl && (
                        <Box>
                          <Tooltip title={t("label.download")}>
                            <IconButton
                              className={classes.downloadBtn}
                              component="a"
                              href={localFile.fileUrl}
                              download={localFile.fileName}
                            >
                              <GetAppIcon />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title={t("button.view")}>
                            <IconButton
                              onClick={() => {
                                setPdfUrl(localFile.fileUrl);
                                setShowPdfModal(true);
                              }}
                              className={classes.downloadBtn}
                            >
                              <i
                                className="fas fa-eye"
                                title={t("button.view")}
                                style={{ cursor: "pointer", color: "#6B7280", fontSize: 16 }}
                              />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      )}
                    </Box>
                  ))}
                </Box>
              </>
            )}

            {current && (
              <>
                <Typography variant="subtitle2" style={{ fontWeight: 700, color: '#374151', marginBottom: 8, marginTop: localFiles.length > 0 ? 16 : (documentName ? 0 : 8), textTransform: 'uppercase' }}>
                  {t("label.currentVersion")}
                </Typography>
            <Box className={classes.row} style={{ border: '1px solid #E5E7EB', borderRadius: 8, padding: 12, marginBottom: 16 }}>
              <Box>
                <Typography className={classes.fileName}>
                  {current.generalName || current.fileS3Name || current[fileNameKey]}
                </Typography>
                <Typography className={classes.fileDate}>
                  {t("label.uploadedDate")}: {current.createdDate ? moment(current.createdDate).format("DD MMM YYYY, HH:mm") : ""}
                </Typography>
              </Box>
              {(current.fileAws3Link || current[fileLinkKey]) && (
                <Box>
                  <Tooltip title={t("label.download")}>
                    <IconButton
                      className={classes.downloadBtn}
                      component="a"
                      href={current.fileAws3Link || current[fileLinkKey]}
                      download={current.fileS3Name || current[fileNameKey]}
                    >
                      <GetAppIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title={t("button.view")}>
                    <IconButton
                      onClick={() => {
                        setPdfUrl(current.fileAws3Link || current[fileLinkKey])
                        setShowPdfModal(true)
                      }}
                      className={classes.downloadBtn}
                    >
                      <i
                        className="fas fa-eye"
                        title={t("button.view")}
                        style={{ cursor: "pointer", color: "#6B7280", fontSize: 16 }} />
                    </IconButton>
                  </Tooltip>
                </Box>
              )}
            </Box>

            {listPast.length > 0 && (
              <>
                <Typography variant="subtitle2" style={{ fontWeight: 700, color: '#374151', marginBottom: 8, marginTop: 16, textTransform: 'uppercase' }}>
                  {t("label.pastVersions")}
                </Typography>
                <Box style={{ border: '1px solid #E5E7EB', borderRadius: 8 }}>
                  {listPast.map((detail, index) => {
                    // if(index === 0) {
                    //   return null;
                    // }
                    const originalIndex = index + 1;
                    const fileName = detail.generalName || detail.fileS3Name || detail[fileNameKey];
                    const fileLink = detail.fileAws3Link || detail[fileLinkKey];

                    return (
                      <Box key={detail.id || originalIndex} className={classes.row}>
                        <Box>
                          <Typography className={classes.fileName}>
                            {fileName}
                          </Typography>
                          <Typography className={classes.fileDate}>
                            {t("label.uploadedDate")}: {detail.createdDate ? moment(detail.createdDate).format("DD MMM YYYY, HH:mm") : ""}
                          </Typography>
                        </Box>
                        {fileLink && (
                          <Box>
                            <Tooltip title={t("label.download")}>
                              <IconButton
                                className={classes.downloadBtn}
                                component="a"
                                href={fileLink}
                                download={fileName}
                              >
                                <GetAppIcon />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title={t("button.view")}>
                              <IconButton
                                onClick={() => {
                                  setPdfUrl(fileLink)
                                  setShowPdfModal(true)
                                }}
                                className={classes.downloadBtn}
                              >
                                <i
                                  className="fas fa-eye"
                                  title={t("button.view")}
                                  style={{ cursor: "pointer", color: "#6B7280", fontSize: 16 }} />
                              </IconButton>
                            </Tooltip>
                          </Box>
                        )}
                      </Box>
                    );
                  })}
                </Box>
              </>
            )}
              </>
            )}
          </>
        ) : (
          <Box textAlign="center" py={4} color="#6B7280">
            {t("clientDocument.noDocuments")}
          </Box>
        )}
      </Box>
      <PreviewDialog open={showPdfModal} setOpen={setShowPdfModal} pdfUrl={pdfUrl} />
    </AppDialog>
  );
};

export default DocumentVersionsModal;
